import { render, staticRenderFns } from "./InputV1.vue?vue&type=template&id=31178912&"
import script from "./InputV1.vue?vue&type=script&lang=js&"
export * from "./InputV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports